import React from "react";
import { HelpIcon } from "../../Icons";

const SecondaryButton = ({ text, icon, ...props }) => {
  return (
    <button
      className="flex w-full space-x-2 bg-background-secondary p-3 rounded-full hover:bg-background-hover disabled:bg-secondary-dsiabled-btn-bg/50 transition-all duration-300 ease-in-out"
      {...props}
    >
      <HelpIcon />
      <p className="text-primary-600 text-sm font-medium leading-normal tracking-tight">
        {text}
      </p>
    </button>
  );
};

export default SecondaryButton;
